export const SIGN_IN = 'SIGN_IN';
export const CEK_COOKIES = 'CEK_COOKIES';
export const FETCH_ERROR = "FETCH_ERROR";
export const SIGN_OUT = 'SIGN_OUT';
export const FETCH_MENU = 'FETCH_MENU';
export const UPLOAD_FILE = 'UPLOAD_FILE';